const getRecordStructure = () => {
    return {
        customerId: '',
        customerName: '',
        refCode: '',
        note: '',
    }
}

const INIT_STATE = {
	loading: false,

    sortOptions: [
        { column: 'created', label: 'Created' }
    ],
    searchField: '',
    sortColumn: 'created',
    sortDirection: 'desc',
    limit: 50,
    selectedSortOption: {column: 'created', label: 'Created'},

    deleted: false,

    details: null, 

    updateId: '',
    updateFlag: 0,
    insertField: getRecordStructure(),
    updateField: getRecordStructure(),
    inserted: false,
    updated: false,

    message: null,

    totalItems: 0,
    
    stats:{
        totalCustomers: 'Loading...',
        totalRevenue: 'Loading...'
    },

    items: []
};

let searchField;
let sortColumn;
let sortDirection;
let limit;

const referralsReducer = (state = INIT_STATE, action) => {
    switch(action.type) {

        case 'REFERRALS_GET':
            searchField = action.payload.searchField?action.payload.searchField:state.searchField;
            sortColumn = action.payload.sortColumn?action.payload.sortColumn:state.sortColumn;
            sortDirection = action.payload.sortDirection?action.payload.sortDirection:state.sortDirection;
            limit = action.payload.limit?action.payload.limit:state.limit;
            return { ...state, items: [], error: null, searchField, sortColumn, sortDirection, limit, loading: true};
        
        case 'REFERRALS_GET_SUCCESS':
            return { ...state, items: action.payload.items, totalItems: action.payload.totalItems, loading: false};

        case 'REFERRALS_GET_ERROR':
            state.error = action.payload;
            return {...state, loadMoreLoading: false};

        case 'REFERRALS_SET_SEARCH_FIELD':
            return { ...state, searchField: action.payload};

        case 'REFERRALS_SET_SORTING':
            let computedSortDirection = state.sortDirection; 
            if(!action.payload.sortDirection) {
                if (action.payload.selectedSortOption.column === state.selectedSortOption.column) {
                    console.log(`Same column changing order`);
                    if (state.sortDirection === "asc") { computedSortDirection = `desc`;} 
                    else { computedSortDirection = `asc`; }
                }
            } else { computedSortDirection = action.payload.sortDirection };
            return {...state, selectedSortOption: action.payload.selectedSortOption, sortDirection: computedSortDirection};

        case 'REFERRALS_LOAD_MORE':
            searchField = action.payload.searchField?action.payload.searchField:state.searchField;
            sortColumn = action.payload.sortColumn?action.payload.sortColumn:state.sortColumn;
            sortDirection = action.payload.sortDirection?action.payload.sortDirection:state.sortDirection;
            limit = action.payload.limit?action.payload.limit:state.limit+50;
            //return { ...state, error: null, searchField, sortColumn, sortDirection, limit, loadMoreLoading: true};
            return {...state, limit, error: null, loadMoreLoading: true};

        case 'REFERRALS_LOAD_MORE_SUCCESS':
            return { ...state, items: [...action.payload.items], totalItems: action.payload.totalItems, loadMoreLoading: false};

        case 'REFERRALS_LOAD_MORE_ERROR':
            state.error = action.payload; 
            return {...state, loading: false};

        case 'REFERRALS_DELETE_ITEM':
            return { ...state, loading: true};
        
        case 'REFERRALS_DELETE_ITEM_SUCCESS':
            return { ...state, loading: false, deleted: true, items: state.items.filter(item => item._id !== action.payload._id)};
        
        case 'REFERRALS_DELETE_ITEM_ERROR':
            state.error = action.payload;
            return { ...state, loading: false};

        case 'REFERRALS_SET_DELETED':
            return { ...state, deleted: true};
        
        case 'REFERRALS_UNSET_DELETED':
            return { ...state, deleted: false, message: null};

        case 'REFERRALS_GET_DETAILS':
            return { ...state, details: null, error: null, loading: true};

        case 'REFERRALS_GET_DETAILS_SUCCESS':
            return { ...state, details: action.payload, loading: false};
        
        case 'REFERRALS_GET_DETAILS_ERROR':
            state.error = action.payload;
            return {...state, loading: false};

        case 'REFERRALS_SET_MESSAGE':
            return { ...state, message: action.payload};

        case 'REFERRALS_UNSET_MESSAGE':
            return { ...state, message: null};
        
        case 'REFERRALS_UNSET_ERROR':
            return { ...state, error: null};

        case 'REFERRALS_SET_INSERT_FIELD':
            state.insertField[action.payload.field] = action.payload.value;
            state.updateFlag ++;
            return { ...state, loading: false};

        case 'REFERRALS_INSERT':
            return { ...state, loading: true};
        
        case 'REFERRALS_INSERT_SUCCESS':
            return { ...state, inserted: action.payload._id, insertField: getRecordStructure(), loading: false};
        
        case 'REFERRALS_INSERT_ERROR':
            state.error = action.payload;
            return { ...state, loading: false};
        
        case 'REFERRALS_UNSET_INSERTED':
            return { ...state, inserted: false};

        case 'REFERRALS_SET_CUSTOMER':
            state.updateFlag ++;
            state.insertField.customerName = action.payload.label;
            state.insertField.customerId = action.payload.value;
            return { ...state};

        case 'REFERRALS_LOAD_UPDATE':
            return { ...state, updateId: action.payload, updateField: getRecordStructure(), loading: true};
        
        case 'REFERRALS_LOAD_UPDATE_SUCCESS':
            delete action.payload.__v;
            delete action.payload.consumptionDates;
            delete action.payload.created;
            delete action.payload._id;
            return { ...state, loading: false, updateField: action.payload};

        case 'REFERRALS_LOAD_UPDATE_ERROR':
            state.error = action.payload;
            return { ...state, loading: false};
        
        case 'REFERRALS_SET_UPDATE_FIELD':
            state.updateField[action.payload.field] = action.payload.value;
            state.updateFlag ++;
            return { ...state, loading: false};

        case 'REFERRALS_UPDATE':
            return { ...state, loading: true};
        
        case 'REFERRALS_UPDATE_SUCCESS':
            state.message = `Record updated successfully`;
            return { ...state, updated: action.payload._id, loading: false};

        case 'REFERRALS_UPDATE_ERROR':
            state.error = action.payload;
            return { ...state, loading: false};

        case 'REFERRALS_UNSET_UPDATED':
            return { ...state, insertField: INIT_STATE.insertField, updated: false};

        case 'REFERRALS_STATS_LOAD_SUCCESS':
            console.log(`Executing action stats load success: `,action.payload)
            return { ...state, stats: action.payload};

        case 'REFERRALS_USE_POINTS':
            return { ...state, loading: true};
        
        case 'REFERRALS_USE_POINTS_SUCCESS':
            state.message = `Points used successfully`;
            return { ...state, details: action.payload, loading: false};

        case 'REFERRALS_USE_POINTS_ERROR':
            state.error = action.payload;
            return { ...state, loading: false};
            
        default:
            return state;
    }
}

export default referralsReducer; 